import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { withClientState } from 'apollo-link-state'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error'
import { createUploadLink } from 'apollo-upload-client'

import {
  setAccessTokens,
  getAccessTokens,
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY
} from '../auth'

import getDeviceId from '../utils/getDeviceId'

const { VUE_APP_GRAPHQL_HOST, VUE_APP_SUBSCRIPTIONS_HOST } = process.env

const cache = new InMemoryCache()

const uploadLink = new createUploadLink({
  uri: `${VUE_APP_GRAPHQL_HOST}`
})

// Set context with tokens
const middlewareLink = setContext(() => {
  const { token, refreshToken } = getAccessTokens()

  const device_id = getDeviceId()

  return {
    headers: {
      [ACCESS_TOKEN_KEY]: token,
      [REFRESH_TOKEN_KEY]: refreshToken,
      device_id
    }
  }
})

// Set tokens after the response
const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const { headers } = operation.getContext()
    if (headers) {
      const token = headers[ACCESS_TOKEN_KEY]
      const refreshToken = headers[REFRESH_TOKEN_KEY]
      setAccessTokens(token, refreshToken)
    }
    return response
  })
})

const errorLink = onError(error => {
  console.error(error)

  if (error.networkError) {
    Vue.prototype.$toast.error('Server error: Please try again later')
  }

  if (error.graphQLErrors) {
    error.graphQLErrors.forEach(err => Vue.prototype.$toast.error(err.message))
  }
})

const stateLink = withClientState({
  cache
})

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: VUE_APP_SUBSCRIPTIONS_HOST,
  options: {
    reconnect: true,
    connectionParams: getAccessTokens()
  }
})

const link = ApolloLink.from([
  afterwareLink,
  stateLink,
  middlewareLink,
  errorLink,
  uploadLink,
  wsLink
])

export const apolloClient = new ApolloClient({
  link,
  cache
})

// Install the vue plugin
Vue.use(VueApollo)

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

export default apolloProvider
